export var TRANSITIONS = {
  SLOW: '1s',
  REGULAR: '0.35s',
  QUICK: '0.13s'
};